import { toast } from '@/helpers/toast/toast.helper'
import { MessageModel } from '@/models/message.model'
import { updateActiveChatMessageAction } from '@/redux/chat/actions'
import { save } from '@/redux/chat/sagas/_http/message'
import { buildOfficialMessage } from '@/redux/chat/sagas/createNewChatSaga/helpers'
import { t } from 'i18next'
import { put } from 'redux-saga/effects'
import { reSendMessageAction } from '../../actions'
import { deleteMessageOnFirebase } from '../_http/message'
import { sendMessageToZApiMultiService } from '../createMessageSaga'
import { buildUnOfficialMessage } from '../createMessageSaga/helpers'
import { buildFilesData, sendMessageOfficialAPI } from '../createMessageSaga/http/message'
import { SendMessageOfficialAPIResponse, SendMessageResponse } from '../createMessageSaga/http/message/types'

export function* reSendMessageSaga(action: ReturnType<typeof reSendMessageAction.request>) {
  const { message, campaign } = action.payload
  try {
    const oldMessageId = message.messageId
    if (message?.isOfficial || campaign?.isOfficial) {
      const sendMessageOfficialAPIResponse: SendMessageOfficialAPIResponse = yield sendMessageOfficialAPI({
        campaignId: campaign.id,
        messageId: message?.templateMessageId,
        phone: message.phone,
        typeSent: message?.typeSent || message?.messageTypeSent,
        phoneNumberId: campaign.phoneNumberId,
        text: message.messageText,
        messageType: message.typeFile,
        isRetryMessage: true,
        caption: message?.messageText,
        filesData: buildFilesData(
          [
            {
              fileUrl:
                message?.audio?.audioUrl ||
                message?.image?.imageUrl ||
                message?.video?.videoUrl ||
                message?.document?.documentUrl ||
                (!!message.files?.length && message?.files[0]?.url),
              mimeType:
                message?.audio?.mimeType ||
                message?.image?.mimeType ||
                message?.video?.mimeType ||
                message?.document?.mimeType ||
                (!!message.files?.length && message?.files[0]?.type),
              type:
                message?.audio?.mimeType ||
                message?.image?.mimeType ||
                message?.video?.mimeType ||
                message?.document?.mimeType ||
                (!!message.files?.length && message?.files[0]?.type)
            }
          ],
          true
        )
      })
      const sendedMessages = buildOfficialMessage(message, sendMessageOfficialAPIResponse)
      yield uploadMessageToFirestore(oldMessageId, sendedMessages[0])
    } else {
      const sendMessageResult: SendMessageResponse = yield sendMessageToZApiMultiService(
        message,
        campaign.id,
        campaign.token
      )
      const sendedMessages = buildUnOfficialMessage(message, sendMessageResult)
      yield uploadMessageToFirestore(oldMessageId, sendedMessages[0])
    }

    yield put(reSendMessageAction.success())
  } catch (error) {
    toast({ type: 'error', message: t('translation:sendMessageError') })
    yield put(reSendMessageAction.failure(error))
  }
}

function* uploadMessageToFirestore(oldMessageId: string, message: MessageModel) {
  yield put(
    updateActiveChatMessageAction({
      oldMessageId,
      newMessageId: message.messageId,
      newMessageStatus: message.status,
      newMessageMoment: message.moment
    })
  )
  yield deleteMessageOnFirebase(oldMessageId)
  yield save(message)
}
